import { config } from "../config";
import TokenProvider from "./TokenProvider";

export default class HttpProvider {
    public static readonly BaseUrl = `https://${window.location.host}`;

    public static GetUrl(
        uriStr: string,
        queryParams?: Record<string, string>
    ): string {
        const url: URL = new URL(uriStr, HttpProvider.BaseUrl);

        if (queryParams) {
            Object.keys(queryParams).forEach((key) =>
                url.searchParams.append(key, queryParams[key])
            );
        }

        return url.toString();
    }

    public static GetRequest = async (
        uriStr: string,
        queryParams?: Record<string, string>
    ) => await HttpProvider._makeHttpRequest("GET", uriStr, queryParams);

    public static PostRequest = async (uriStr: string, bodyObj?: unknown) =>
        await HttpProvider._makeHttpRequest(
            "POST",
            uriStr,
            undefined,
            bodyObj ? JSON.stringify(bodyObj) : undefined
        );

    public static PostFormRequest = async (
        uriStr: string,
        formData: FormData
    ) =>
        await HttpProvider._makeHttpRequest(
            "POST",
            uriStr,
            undefined,
            formData
        );

    public static PatchRequest = async (uriStr: string, bodyObj: {}) =>
        await HttpProvider._makeHttpRequest(
            "PATCH",
            uriStr,
            undefined,
            JSON.stringify(bodyObj)
        );

    public static JsonPatchRequest = async (uriStr: string, bodyObj: {}) =>
        await HttpProvider._makeHttpRequest(
            "PATCH",
            uriStr,
            undefined,
            JSON.stringify(bodyObj),
            "application/json-patch+json"
        );

    public static DeleteRequest = async (
        uriStr: string,
        queryParams?: Record<string, string>
    ) => await HttpProvider._makeHttpRequest("DELETE", uriStr, queryParams);

    private static async _makeHttpRequest(
        method: "GET" | "POST" | "PATCH" | "DELETE",
        uriStr: string,
        queryParams?: Record<string, string>,
        bodyObj?: FormData | string,
        contentType = "application/json"
    ): Promise<Response> {
        const url = this.GetUrl(uriStr, queryParams);
        const options = { method } as RequestInit;
        let headers: { [key: string]: string } = {};

        // ensure body included on request (if needed)
        if (bodyObj && (method === "POST" || method === "PATCH")) {
            options.body = bodyObj;
            headers = { Accept: "application/json" };

            if (!(bodyObj instanceof FormData)) {
                headers["Content-Type"] = contentType;
            }
        }

        headers["App-Version"] = config.VITE_APP_VERSION || "unknown";

        // ensure token included on request
        const token = TokenProvider.GetStoredToken();
        if (token) {
            options.headers = {
                ...headers,
                Authorization: `Bearer ${token}`
            };
        } else {
            options.headers = headers;
        }

        return await fetch(url, options);
    }
}
